import React from 'react';
import './style.scss';
import Advisory from './Advisory';
import Team from './Team';

const Body = () => {
  return (
    <>
      <Team />
      <Advisory />
    </>
  );
};

export default Body;
